module.exports = __webpack_public_path__ + "img/smallChevron.e814839d.svg";